class SliderReviews extends HTMLElement {
  constructor() {
    super();

    this.sliderElement = this.querySelector("[data-slider-main]");
    this.swiperInstance = null;

    if (this.sliderElement) {
      this.initSwiper();
    }
  }

  initSwiper() {
    this.swiperInstance = new Swiper(this.sliderElement, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      loop: true,
      navigation: {
        nextEl: '.reviews__control-next',
        prevEl: '.reviews__control-prev',
      },
      breakpoints: {
        990: {
          slidesPerView: parseInt(this.sliderElement.dataset.slidesPerPage),
          spaceBetween: 96
        },
      },
    });
  }

}

customElements.define("slider-reviews", SliderReviews);
